import { HTTP_STATUS_ERRORS } from './errorMessages';

export const generateCognitoDialogMessage = ({ error }) => {
  if (error.code === 'NetworkError' && error.message === 'Network error') {
    return HTTP_STATUS_ERRORS.NO_INTERNET;
  }
  switch (error.code) {
    case 'ForbiddenException':
      return {
        title: 'エラー',
        body: `アプリケーションエラーが発生しました。<br>
          しばらくたってからもう一度お試しください。`,
        hideCloseIcon: false,
        code: '400(ForbiddenException)',
      };
    case 'InvalidParameterException':
      return {
        title: 'エラー',
        body: `アプリケーションエラーが発生しました。<br>
          しばらくたってからもう一度お試しください。`,
        hideCloseIcon: false,
        code: '400(InvalidParameterException)',
      };
    case 'InvalidPasswordException':
      return {
        title: 'エラー',
        body: `パスワードが間違っているようです。`,
        hideCloseIcon: false,
        code: '400(InvalidPasswordException)',
      };
    case 'LimitExceededException':
      return {
        title: 'エラー',
        body: `アプリケーションエラーが発生しました。<br>
          しばらくたってからもう一度お試しください。`,
        hideCloseIcon: false,
        code: '400(LimitExceededException)',
      };
    case 'CodeMismatchException':
      return {
        title: 'エラー',
        body: `認証コードが正しくありません。`,
        hideCloseIcon: false,
      };
    case 'ExpiredCodeException':
      return {
        title: 'エラー',
        body: `認証コードの有効期限が切れています。`,
        hideCloseIcon: false,
      };
    case 'NotAuthorizedException':
      return {
        title: 'エラー',
        body: `メールアドレスまたはパスワードが間違っているようです。`,
        hideCloseIcon: false,
        code: '400(NotAuthorizedException)',
      };
    case 'NotAuthorizedException.ChangePassword':
      return {
        title: 'エラー',
        body: `「現在のパスワード」が正しくありません。`,
        hideCloseIcon: false,
      };
    case 'NotAuthorizedException.AuthCode':
      return {
        title: 'エラー',
        body: `認証できませんでした。<br>
          前の画面に戻り、最初からやり直してください。`,
        hideCloseIcon: false,
      };
    case 'PasswordResetRequiredException':
      return {
        title: 'エラー',
        body: `パスワードのリセットが必要です。`,
        hideCloseIcon: false,
        code: '400(PasswordResetRequiredException)',
      };
    case 'ResourceNotFoundException':
      return {
        title: 'エラー',
        body: `アプリケーションエラーが発生しました。<br>
          しばらくたってからもう一度お試しください。`,
        hideCloseIcon: false,
        code: '400(ResourceNotFoundException)',
      };
    case 'TooManyRequestsException':
      return {
        title: 'エラー',
        body: `アプリケーションエラーが発生しました。<br>
          しばらくたってからもう一度お試しください。`,
        hideCloseIcon: false,
        code: '400(TooManyRequestsException)',
      };
    case 'UserNotConfirmedException':
      return {
        title: 'エラー',
        body: `該当のユーザが見つかりませんでした。`,
        hideCloseIcon: false,
        code: '400(UserNotConfirmedException)',
      };
    case 'UserNotFoundException':
      return {
        title: 'エラー',
        body: `該当のユーザが見つかりませんでした。`,
        hideCloseIcon: false,
        code: '400(UserNotFoundException)',
      };

    default:
      return {
        title: `認証エラー`,
        body: `認証の有効期限切れ、もしくは認証エラーのため<br>
          ログアウトします。`,
        hideCloseIcon: true,
        status: 401,
      };
  }
};
